import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';

import { HintComponent } from './hint.component';

@NgModule({
  declarations: [HintComponent],
  exports: [HintComponent],
  imports: [CommonModule, MaterialModule]
})
export class HintModule {}
